<template>
  <div class="report_wrap">
    <!-- 搜索 -->
    <report-search reportTitle="roi.title" @search="filterData"></report-search>
    <!-- 报表 -->
    <div class="box">
      <a-row :gutter="24">
        <a-col :xl="{span: 12}" :xxl="{span: 6}">
          <div class="col_box report_num">
            <div>{{ $t('roi.panelTitle[0]') }}</div>
            <div class="count">
              <countTo :startVal="0" :endVal="robotNum" :duration="1500"></countTo>
            </div>
          </div>
        </a-col>
        <a-col :xl="{span: 12}" :xxl="{span: 6}">
          <div class="col_box report_num">
            <div>{{ $t('roi.panelTitle[1]') }}</div>
            <div class="count">
              <countTo :startVal="0" :endVal="robotTime" :duration="1500"></countTo>
            </div>
          </div>
        </a-col>
        <a-col :xl="{span: 24}" :xxl="{span: 12}">
          <div class="col_box log_box" style="height:300px;">
            <div class="title">{{ $t('roi.invest') }}</div>
            <v-chart :forceFit="true" :height="300" :data="lindeData" :scale="scale" :padding="[80, 50, 30, 70]">
              <v-tooltip />
              <v-legend
                position="top-right"
                layout="horizontal"
                :offsetY="-30"
                :offsetX="28"
                :custom="true"
                :items="legendItems"
                :on-click="legendOnClick"/>
              <v-axis dataKey="savingTime" color="#999" :grid="null"/>
              <v-axis dataKey="temperature" color="#999" :grid="{ lineStyle: { lineDash: [1, 0]} }"/>
              <!-- <v-smooth-line position="time*temperature" :color="['minute', ['#009944', '#FF5B82']]" shape="smooth"/> -->
              <v-smooth-line position="time*temperature" color="minute" />
              <v-smooth-line position="time*savingTime" color="#D7D7D7" :v-style="{lineDash: [2, 10]}"/>
            </v-chart>
          </div>
        </a-col>
      </a-row>
      <div class="log_box">
        <div :class="{title: true, isPos: pagination.total}">{{ $t('roi.panelTitle[2]') }}</div>
        <a-table :columns="columns" :dataSource="dataList" :pagination="pagination" rowKey="id"></a-table>
      </div>
    </div>
  </div>
</template>

<script>
import countTo from 'vue-count-to'
import { apiRoi } from '@/api/roi'
const DataSet = require('@antv/data-set')

// const sourceData = [
//   { time: '10:10', robot: 4, people: 3, savingTime: 90 },
//   { time: '10:15', robot: 2, people: 6, savingTime: 59 },
//   { time: '10:20', robot: 13, people: 20, savingTime: 25 },
//   { time: '10:25', robot: 23, people: 9, savingTime: 26 },
//   { time: '10:30', robot: 5, people: 11, savingTime: 36 },
//   { time: '10:35', robot: 8, people: 7, savingTime: 23 },
//   { time: '10:40', robot: 14, people: 1, savingTime: 24 }
// ]

export default {
  components: {
    countTo
  },
  data () {
    return {
      // 折线图数据
      lindeData: [],
      scale: [
        {
          dataKey: 'time'
        },
        {
          dataKey: 'minute'
        },
        {
          dataKey: 'savingTime',
          alias: '节约时间%'
        }
      ],
      // 折线图legend
      legendItems: [
        { label: 'savingTime', value: this.$t('roi.lineArr[0]'), marker: { symbol: 'circle', fill: '#D7D7D7' } },
        { label: 'temperature', value: this.$t('roi.lineArr[1]'), marker: { symbol: 'circle', fill: '#2fc25b' } },
        { label: 'temperature', value: this.$t('roi.lineArr[2]'), marker: { symbol: 'circle', fill: '#1890ff' } }
      ],
      // 折线图legend点击事件
      legendOnClick: (ev, chart) => {
        const legendItem = ev.item
        const geoms = chart.getAllGeoms()
        for (let i = 0; i < geoms.length; i++) {
          const geom = geoms[i]
          if (geom.getYScale().field === legendItem.label) {
            if (ev.checked) {
              geom.show()
            } else {
              geom.hide()
            }
          }
        }
      },
      // 业务日志列表
      dataList: [],
      // 业务日志-表格列
      columns: [
        {
          title: this.$t('roi.logTab[0]'),
          dataIndex: 'scheduleTime',
          customRender: text => {
            return text || '-'
          }
        },
        {
          title: this.$t('roi.logTab[1]'),
          dataIndex: 'robotName',
          customRender: text => {
            return text || '-'
          }
        },
        {
          title: this.$t('roi.logTab[2]'),
          dataIndex: 'procName',
          customRender: text => {
            return text || '-'
          }
        },
        {
          title: this.$t('roi.logTab[3]'),
          dataIndex: 'performTime',
          customRender: text => {
            return text === undefined ? '-' : text
          }
        },
        {
          title: this.$t('roi.logTab[4]'),
          dataIndex: 'artificialTime',
          customRender: text => {
            return text === undefined ? '-' : text
          }
        }
      ],
      // 业务日志分页
      pagination: {
        position: 'top',
        size: 'small',
        current: 1,
        total: 0,
        showTotal: total => { return this.$t('operation.totalRecords', { total }) },
        onChange: this.changePage
      },
      // 数据筛选条件
      initParams: {
        robotName: '', // 机器人名称
        procName: '', // 流程名
        queryStart: '', // 开始时间
        queryEnd: '', // 结束时间
        queryMode: '', // 查询模式  键值： 1 今天，2 昨天，3本周，4 上周，5 本月，6 上月
        interval: '' // 间隔
      },
      // 机器人数
      robotNum: 0,
      // 机器人运行时间
      robotTime: 0
    }
  },
  created () {
    this._fetchData()
  },
  methods: {
    filterData (par) {
      this.initParams = par
      this._fetchData()
    },
    /**
     * 获取数据
     */
    _fetchData () {
      apiRoi.investLine(this.initParams).then(res => {
        const list = res || []
        const dv = new DataSet.View().source(list)
        dv.transform({
          type: 'rename',
          map: {
            robot: this.$t('roi.lineArr[2]'),
            people: this.$t('roi.lineArr[1]')
          }
        }).transform({
          type: 'fold',
          fields: [this.$t('roi.lineArr[2]'), this.$t('roi.lineArr[1]')],
          key: 'minute',
          value: 'temperature'
        })
        this.lindeData = dv.rows
        // console.log(this.lindeData)
      })
      apiRoi.robot(this.initParams).then(data => {
        this.robotNum = data || 0
      })
      apiRoi.robotTime(this.initParams).then(data => {
        this.robotTime = data || 0
      })
      this.changePage(1)
    },
    /**
     * 业务日志列表
     */
    fetchList () {
      apiRoi.task(this.initParams, this.pagination.current).then(data => {
        this.dataList = data.items
        this.pagination.total = data.total
      })
    },
    /**
     * 业务日志分页
     */
    changePage (page) {
      this.pagination.current = page
      this.fetchList()
    }
  }
}
</script>

<style lang="less" scoped>
.report_wrap {
  .box {
    .col_box {
      background: #fff;
      margin-bottom: 24px;
    }
    @media (min-width: 1200px) {
      .ant-col-xl-12 {
        height: 224px;
        margin-bottom: 24px;
        .report_num {
          .count {
            line-height: 156px;
          }
        }
      }
    }
    @media (min-width: 1600px) {
      .ant-col-xxl-6 {
        height: 300px;
        margin-bottom: 24px;
        .report_num {
          .count {
            line-height: 256px;
          }
        }
      }
    }
    .report_num {
      padding: 24px;
      color: #666;
      height: 100%;
      .count {
        font-size: 60px;
        font-weight:bold;
        text-align: center;
      }
    }
    .log_box {
      background: #fff;
      position: relative;
      padding-bottom: 30px;
      .ant-table-wrapper {
        padding: 0 24px;
      }
      .title {
        // position: absolute;
        &.isPos {
          position: absolute;
        }
        top: 0;
        left: 0;
        width: 100%;
        padding: 18px 24px;
        border-bottom: 1px solid #eee;
        font-size: 16px;
        color: #333;
      }
      /deep/.ant-table {
        padding-top: 13px;
      }
      /deep/.ant-pagination-item,
      /deep/.ant-pagination-item-ellipsis,
      /deep/.ant-pagination-jump-prev,
      /deep/.ant-pagination-jump-next {
        display: none;
      }
    }
    .col_box {
      .title {
        position: absolute;
        padding: 17px 24px;
        font-size: 16px;
        border-bottom: 2px solid #D9D9D9;
      }
    }
  }
}
.line_viser {
  // width: 800px;
  height: 400px;
  background: #fff;
}
</style>
